module.exports = __webpack_public_path__ + "static/car.817c1baf.jpg";